import { useQuery } from 'convex/react';
import { api } from '@aeon-karaoke/cloud-convex';
import { feedbackUrl } from '@aeon-karaoke/shared/aeon-karaoke/constant/feedback';
import { useCurrentUser } from './useCurrentUser';

/** The feedback form link for this build and account: null while the form URL
 * loads and on a deployment that names none, so callers render nothing. */
export function useFeedbackUrl() {
  const form = useQuery(api.feedback.formUrl, {});
  const { user } = useCurrentUser();
  return feedbackUrl(form, { app: 'web', version: __AEON_COMMIT__, platform: navigator.userAgent, handle: user?.handle });
}
